<template>
<div>
  <div class="col-md-12 card">
    <div class="card-content row">
      <div class="col-sm-6 col-md-9">
      </div>
      <div class="col-sm-6 col-md-3">
        <p-search @on-search="handleSearch($event)"/>
      </div>

      <div class="col-sm-12">
        <el-table
          class="table-striped"
          :data="tableData"
          :default-sort="{prop: 'createdAt', order: 'descending'}"
          @sort-change="handleSort($event)"
          style="width: 100%"
          v-loading="loading"
        >

          <el-table-column
            prop="invoice"
            label="NF Fabricante"
          >
            <template slot-scope="scope">
            <el-popover
              trigger="hover"
              placement="top"
            >
              <p>NF Concessionária: {{ scope.row.invoicePowerCompany }}</p>
              <p>Descrição: {{ scope.row.description }}</p>
              <div
                slot="reference"
                class="name-wrapper"
              >
                <i class="ti-info-alt"></i> {{ scope.row.invoice }}
              </div>
            </el-popover>
            </template>
          </el-table-column>

          <el-table-column
            prop="numberOfRefigerators"
            label="Qtde"
            :width="60"
          />

          <el-table-column
            prop="eventId"
            label="Evento"
            :min-width="120"
          >
            <template slot-scope="scope">
            <el-popover
              v-if="events instanceof Object"
              trigger="hover"
              placement="top"
            >
              <p>Município: {{ events.hasOwnProperty(scope.row.eventId) ? events[scope.row.eventId].city : '' }}</p>
              <p>Referência: {{ events.hasOwnProperty(scope.row.eventId) ? events[scope.row.eventId].reference : '' }}</p>
              <p>Cidade: {{ events.hasOwnProperty(scope.row.eventId) ? events[scope.row.eventId].city : '' }}</p>
              <div
                slot="reference"
                class="name-wrapper"
              >
                <i class="ti-info-alt"></i>{{ events.hasOwnProperty(scope.row.eventId) ? events[scope.row.eventId].reference : '' }}
              </div>
            </el-popover>
            </template>
          </el-table-column>

          <el-table-column
            prop="createdAt"
            label="Criado Em"
            sortable="custom"
            :min-width="100"
          >
            <template slot-scope="scope">
            {{ new Date(scope.row.createdAt) | moment('DD/MM/YYYY HH:mm:ss') }}
            </template>
          </el-table-column>

          <el-table-column
            prop="userId"
            label="Criado Por"
            :min-width="120"
          >
            <template slot-scope="scope">
            {{ getUserStock(scope.row.userId) }}
            </template>
          </el-table-column>

          <el-table-column
            :min-width="120"
            fixed="right"
            label=""
          >
            <template slot-scope="props">
            <div class="text-right">
              <router-link :to="{name: 'stock.edit', params: {id: props.row._id}}">
                <a
                  v-if="$can('stock.edit')"
                  class="btn btn-primary btn-fill btn-icon edit"
                  title="Editar estoque"
                ><i class="ti-pencil-alt"></i></a>
              </router-link>
            </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="col-sm-12 text-center">
        <p-pagination
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="pagination.total"
        ></p-pagination>
      </div>
    </div>
  </div>
  <div class="col-sm-12 pagination-info text-right">
    <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
  </div>
</div>
</template>
<script>
import swal from 'sweetalert2'
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      pagination: {
        perPage: 20,
        currentPage: 1,
        total: 0
      },
      sort: {
        field: 'createdAt',
        direction: 'desc'
      },
      search: {
        query: '',
        fields: ['description', 'invoice', 'invoicePowerCompany']
      }
    }
  },

  watch: {
    currentPage: function (currentPage) {
      this.fetch()
    }
  },

  computed: {
    ...mapGetters('stocks', {
      tableData: 'stocks',
      loading: 'loading',
      count: 'count'
    }),
    ...mapGetters('users', { users: 'usersIdName' }),

    ...mapGetters('events', {
      events: 'modelById'
    }),

    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total () {
      this.pagination.total = this.count
      return this.count
    },
    currentPage () {
      return this.pagination.currentPage
    }
  },

  methods: {
    ...mapActions('stocks', ['fetchAll', 'delete', 'countAllReduce']),
    ...mapActions('events', {
      fetchEventsByIds: 'fetchIds'
    }),

    fetch () {
      let query = {}
      if (this.pagination.perPage) {
        query['limit'] = this.pagination.perPage
      }
      if (this.from) {
        query['skip'] = this.from
      }
      if (this.sort.field && this.sort.direction) {
        query['sort'] = this.sort
      }
      if (this.search) {
        query['search'] = this.search
      }
      this.fetchAll(query)
        .then((response) => {
          this.fetchEventsByIds({
            connection: 'default',
            ids: response.map(item => Object.assign({ id: item.eventId }))
          })
        })
        .catch(err => console.log(err))
    },
    handleSearch (query) {
      this.search.query = query
      this.fetch()
    },
    handleSort (sort) {
      this.sort = { field: sort.prop, direction: sort.order }
      this.fetch()
    },
    handleDelete (index, row) {
      swal({
        title: 'Você tem certeza?',
        text: `Não será possível reverter essa ação!`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Sim, pode deletar!',
        buttonsStyling: false
      }).then(() => {
        this.delete(row._id).then(result => {
          this.$notify({
            message: 'Registro deletado com sucesso.',
            type: 'success'
          })
          this.fetch()
        }).catch(err => console.log(err))
      })
    },
    getUserStock (id) {
      return this.users.hasOwnProperty(id) ? this.users[id] : '-'
    }
  },

  mounted () {
    this.fetch()
    this.countAllReduce()
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Stock/StockIndex.vue